<template>
  <div>
    <v-flex xs12>
      <v-text-field label="Nome"></v-text-field>
    </v-flex>
    <v-flex xs12>
      <v-text-field label="Cpf"></v-text-field>
    </v-flex>
    <v-flex xs12>
      <v-text-field  label="Rg"></v-text-field>
    </v-flex>
    <v-flex xs12>
      <v-text-field  label="E-mail"></v-text-field>
    </v-flex>
  </div>
</template>

<script>
  export default {

  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PhysicalPersonForm.vue